import { useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import OptionsButtonCustom from "../../../../../components/option-button/OptionsButtonCustom";
import TableRowCommon from "../../../../../components/table/TableRowCommon";
import {
  setLoading,
  unsetLoading,
} from "../../../../../store/loading/loading.slice";
import StateComponents from "../../../../../components/state-component/StateComponents";
import { debouncedApiCall } from "../../../../../utils/app.utils";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import TableCustom from "../../../../../components/table/tableCustom";
import { routeName } from "../../../../../routes/routeName";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { dateTimeToView } from "../../../../../utils/date.utils";
import { edpexProjectAmendmentAPI } from "../../../../../api/edpex-project-amendment/edpex-project-amendment.api";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../../../components/alert/swal";
import StatusCustom from "../../../../../components/status/statusCustom";
import moment from "moment";
import { edpex_project_amendment_status, expex_project_amendment_name_data } from "../../enum/enum";

const SpecailEditProject = ({
  isApprove,
  reloadTrigger,
  setShowModalSpecialEdit,
  setInputValueSpecialEdit,
  idEdpexProject,
}: {
  isApprove: boolean;
  reloadTrigger?: boolean;
  setShowModalSpecialEdit?: React.Dispatch<React.SetStateAction<string>>;
  setInputValueSpecialEdit?: React.Dispatch<React.SetStateAction<any>>;
  idEdpexProject?: number;
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate: NavigateFunction = useNavigate();
  const { id } = useParams();

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(13);
  const [sortBy, setSortBy] = useState<string>("modified_date");
  const [sortType, setSortType] = useState<string>("DESC");
  const [search, setSearch] = useState<string>("");
  const [data, setData] = useState<any[]>([]);



  const [expex_project_amendment_name, set_expex_project_amendment_name] = useState<{ label: string, value: string }>();
  const [start_date, set_start_date] = useState<string>("");
  const [end_date, set_end_date] = useState<string>("");
  const [status, set_status] = useState<any>(null);

  const handleChangeDateRange = (st: string, end: string) => {
    set_start_date(st);
    set_end_date(end)
  }


  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const handleGetDataOne = async (id: number) => {
    try {
      dispatch(setLoading());

      const res = await edpexProjectAmendmentAPI.getEdpexProjecAmendmenttById(
        id
      );

      if (res.data?.status < 300 && res.data?.data) {
        setInputValueSpecialEdit &&
          setInputValueSpecialEdit(
            // res.data?.data
            {
              id_edpex_project_amendment:
                res.data?.data?.id_edpex_project_amendment,
              edpex_project_amendment_name:
                res.data?.data?.edpex_project_amendment_name,
              id_edpex_project_budget:
                res.data?.data?.edpex_amendment_detail?.id_edpex_project_budget,
              fiscal_year:
                +res.data?.data?.edpex_amendment_detail?.fiscal_year + 543,
              fiscal_month:
                res.data?.data?.edpex_amendment_detail?.fiscal_month,
              edpex_project_budget_amount:
                res.data?.data?.edpex_amendment_detail
                  ?.edpex_project_budget_amount,
              edpex_project_start_date:
                res.data?.data?.edpex_amendment_detail
                  ?.edpex_project_start_date,
              edpex_project_end_date:
                res.data?.data?.edpex_amendment_detail?.edpex_project_end_date,
              edpex_project_amendment_remark:
                res.data?.data.edpex_project_amendment_remark,
              edpex_project_amendment_status:
                res.data?.data?.edpex_project_amendment_status,
              id_edpex_project: res.data?.data?.id_edpex_project,
              edpex_project_amendment_remark_cancel: res.data?.data?.edpex_project_amendment_remark_cancel || ""
            }
          );
      }
    } catch (error: any) {
      console.error("Get data error:", error);
    } finally {
      dispatch(unsetLoading());
    }
  };

  const headCells = [
    {
      id: "ปีงบประมาณ",
      width: 100,
      sortable: true,
      disablePadding: false,
      align: "center",
      label: t("ปีงบประมาณ"),
    },
    {
      id: "ชื่อโครงการ",
      disablePadding: false,
      align: "center",
      width: 141,
      label: t("ชื่อโครงการ"),
    },
    {
      id: "ประเภทข้อมูลที่ต้องการแก้ไข",
      disablePadding: false,
      align: "center",
      width: 257,
      label: t("ประเภทข้อมูลที่ต้องการแก้ไข"),
    },
    {
      id: "ชื่อผู้ส่งคำร้อง",
      disablePadding: false,
      align: "center",
      width: 257,
      label: t("ชื่อผู้ส่งคำร้อง"),
    },
    {
      id: "วันที่ส่งคำร้อง",
      width: 100,
      sortable: true,
      disablePadding: false,
      align: "center",
      label: t("วันที่ส่งคำร้อง"),
    },
    {
      id: "สถานะ",
      disablePadding: false,
      align: "center",
      width: 141,
      label: t("สถานะ"),
    },
    {
      id: "s",
      disablePadding: false,
      align: "center",
      width: 100,
      class: matches,
      label: "",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      fiscal_year,
      id_edpex_project_amendment,
      edpex_project_name,
      edpex_project_amendment_name,
      created_name,
      created_date,
      edpex_project_amendment_status,
    } = objData;

    const objRenderData = {
      key: no,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "left",
          label: fiscal_year ? +fiscal_year + 543 : +fiscal_year,
        },
        {
          option: "TEXT",
          align: "center",
          label: edpex_project_name ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: edpex_project_amendment_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: created_name ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: created_date ? dateTimeToView(created_date) : "-",
        },
        {
          option: "COMPONENT",
          align: "center",
          component: (
            <StatusCustom
              disableMaxWidth
              text={
                edpex_project_amendment_status === "PENDING"
                  ? "รอการอนุมัติ"
                  : edpex_project_amendment_status === "APPROVE"
                    ? "อนุมัติแล้ว"
                    : edpex_project_amendment_status === "REJECT"
                      ? "ไม่อนุมัติ"
                      : ""
              }
              type={
                edpex_project_amendment_status === "PENDING"
                  ? "pending"
                  : edpex_project_amendment_status === "APPROVE"
                    ? "approve"
                    : edpex_project_amendment_status === "REJECT"
                      ? "reject"
                      : ""
              }
            />
          ),
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          width: 300,
          component: (
            <div className="flex justify-center items-center">
              <OptionsButtonCustom
                enableView
                enableEdit={isApprove}
                enableDelete={edpex_project_amendment_status === "PENDING"}
                onEditClick={() => {
                  if (isApprove) {
                    navigate(
                      routeName.cms.edpexSpecialEditRequestDetail.replace(
                        ":id",
                        id_edpex_project_amendment
                      ) + "?mode=VIEW"
                    );
                    if (idEdpexProject) {
                      setShowModalSpecialEdit?.("EDIT");
                    }
                  } else {
                    setShowModalSpecialEdit?.("EDIT");
                    handleGetDataOne(id_edpex_project_amendment);
                  }
                }}
                onViewClick={() => {
                  if (isApprove) {
                    navigate(
                      routeName.cms.edpexSpecialEditRequestDetail.replace(
                        ":id",
                        id_edpex_project_amendment
                      ) + "?mode=VIEW"
                    );
                    if (idEdpexProject) {
                      setShowModalSpecialEdit?.("EDIT");
                    }
                  } else {
                    setShowModalSpecialEdit?.("VIEW");
                    handleGetDataOne(id_edpex_project_amendment);
                    // setInputValueSpecialEdit?.(objData);
                  }
                }}
                onDeleteClick={() => {
                  alertActive(
                    "ลบการขอแก้ไขพิเศษ",
                    "ท่านต้องการลบการขอแก้ไขพิเศษ ใช่หรือไม่",
                    undefined,
                    undefined,
                    async () => {
                      dispatch(setLoading());
                      await edpexProjectAmendmentAPI
                        .deleteEdpexProjecAmendmentt(+id_edpex_project_amendment)
                        .then((res) => {
                          if (res.status < 300) {
                            alertSuccess(
                              "ลบการขอแก้ไขพิเศษ เรียบร้อย",
                              undefined,
                              undefined,
                              () => {
                                if (id) {
                                  handleGetData(+id);
                                } else {
                                  handleGetData(0);
                                }
                              }
                            );
                          }
                        })
                        .catch(() => {
                          alertError("ลบการขอแก้ไขพิเศษ ไม่สำเร็จ");
                        })
                        .finally(() => {
                          dispatch(unsetLoading());
                        });
                    }
                  );
                }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleGetData = useCallback(
    async (id: number) => {
      let query: any = {
        page: page,
        limit: pageLimit,
        id_edpex_project: id > 0 ? id : "",
      };
      if (search) query = { ...query, keyword: search };
      if (start_date) query.start_date = moment(start_date).format("YYYY-MM-DD");
      if (end_date) query.end_date = moment(end_date).format("YYYY-MM-DD");
      if (expex_project_amendment_name) query.edpex_project_amendment_name = expex_project_amendment_name?.value;
      if (status) query.status = status?.value;
      dispatch(setLoading());
      await edpexProjectAmendmentAPI
        .getEdpexProjecAmendmenttList(query)
        .then((res) => {
          if (res.status < 300) {
            setData(res.data?.data?.items || []);
            setTotalItems(res.data?.data?.meta?.totalItems || 0);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    },
    [page, pageLimit, search, reloadTrigger, start_date, end_date, expex_project_amendment_name, status]
  );

  useEffect(() => {
    if (isApprove && idEdpexProject) {
      handleGetData(+idEdpexProject);
    } else {
      if (id) {
        handleGetData(+id);
      } else {
        handleGetData(0);
      }
    }
  }, [handleGetData, idEdpexProject]);

  return (
    <>
      <>
        <div className="w-full flex justify-between">
          <span className="flex-1">
            <StateComponents
              otherProps={{ spacing: 2 }}
              typeProps={[
                {
                  seq: 1,
                  type: "TEXT_FIELD",
                  gridProps: {
                    xs: 12,
                    md: 2,
                  },
                  fieldProps: {
                    startAdornment: <SearchOutlinedIcon />,
                    placeholder: t("ค้นหา ชื่อผู้ส่งคำร้อง"),
                    onChange: (e) =>
                      debouncedApiCall({
                        searchItem: e.target.value,
                        setItem: setSearch,
                      }),
                  },
                },
                {
                  seq: 2,
                  type: "AUTO-COMPLETE",
                  gridProps: {
                    xs: 12,
                    md: 3,
                  },
                  fieldProps: {
                    labelId: "ss",
                    placeholder: "ทุกประเภทข้อมูลที่ต้องการแก้ไข",
                    onChange: (_, val) => set_expex_project_amendment_name(val ?? undefined),
                    options: expex_project_amendment_name_data,
                    value: expex_project_amendment_name || null,
                    getOptionLabel: (op) => op?.label || "",
                  },
                },
                {
                  seq: 3,
                  type: "DATE_RANGE2",
                  gridProps: {
                    xs: 12,
                    xl: 3,
                  },
                  fieldProps: {
                    handleChange: (st, end) => {
                      handleChangeDateRange(st ?? "", end ?? "")
                    },
                    placeholder: "ช่วงวันที่",
                    value: {
                      end_date,
                      start_date
                    },
                  },
                },
                {
                  seq: 4,
                  type: "AUTO-COMPLETE",
                  gridProps: {
                    xs: 12,
                    xl: 3,
                  },
                  fieldProps: {
                    labelId: "AA",
                    placeholder: "สถานะ",
                    onChange: (_, val) => set_status(val ?? null),
                    getOptionLabel: (op) => op?.label,
                    options: edpex_project_amendment_status,
                    value: status || null,
                  },
                },
              ]}
            />
          </span>
        </div>
        <div className="mt-10">
          <section className="w-full mt-10">
            <TableCustom
              tableMinWidth={1920}
              tableFixedWidth
              customScroll
              page={page}
              pageLimit={pageLimit}
              sortBy={sortBy}
              sortType={sortType}
              headCells={headCells}
              rowCount={totalItems}
              rowsData={data?.map((data: any, i: any) => {
                return renderData(data, i);
              })}
              onSort={handleRequestSort}
              setPageLimit={(value: number) => setPageLimit(value)}
              setPage={(value: number) => setPage(value)}
            />
          </section>
        </div>
      </>
    </>
  );
};

export default SpecailEditProject;
